import { type AnyMaskedOptions, MaskedRange } from 'imask'

type MaskedRangeConfig = {
  from: number
  to: number
}

export const createMaskedRange = ({ from, to }: MaskedRangeConfig): AnyMaskedOptions => ({
  mask: MaskedRange,
  maxLength: to.toString().length,
  autofix: false,
  from,
  to,
  lazy: false,
})
